import { ReportSettingRowVisibility } from "@common/types/reports/report-settings";
import {
    PreviewLedgerRow,
    PreviewStatementRow,
    PreviewTrialBalanceRow,
} from "./previewTypes";

const showsEveryRow = (rowVisibility: ReportSettingRowVisibility): boolean =>
    rowVisibility === ReportSettingRowVisibility.ALL_ACCOUNTS;

const keepsZeroRow = (params: {
    rowVisibility: ReportSettingRowVisibility;
    hasActivity: boolean | undefined;
}): boolean =>
    params.rowVisibility === ReportSettingRowVisibility.WITH_ACTIVITY &&
    params.hasActivity === true;

export const filterStatementRows = (
    rows: PreviewStatementRow[],
    rowVisibility: ReportSettingRowVisibility,
): PreviewStatementRow[] => {
    if (showsEveryRow(rowVisibility)) {
        return rows;
    }

    return rows.filter((row) => {
        if (row.kind !== "line") {
            return true;
        }

        const isZero = (row.amount ?? 0) === 0;
        return (
            !isZero ||
            keepsZeroRow({ rowVisibility, hasActivity: row.hasActivity })
        );
    });
};

export const filterTrialBalanceRows = (
    rows: PreviewTrialBalanceRow[],
    rowVisibility: ReportSettingRowVisibility,
): PreviewTrialBalanceRow[] => {
    if (showsEveryRow(rowVisibility)) {
        return rows;
    }

    return rows.filter((row) => {
        if (row.kind !== "line") {
            return true;
        }

        const isZero = row.debit === 0 && row.credit === 0;
        return (
            !isZero ||
            keepsZeroRow({ rowVisibility, hasActivity: row.hasActivity })
        );
    });
};

export const filterLedgerRows = (
    rows: PreviewLedgerRow[],
    rowVisibility: ReportSettingRowVisibility,
): PreviewLedgerRow[] => {
    if (showsEveryRow(rowVisibility)) {
        return rows;
    }

    return rows.filter((row) => !row.isNeverUsed);
};
